export const EventFieldOptionsConfigTypes = {
  EventType: 'eventType',
  Location: 'location',
  LocationType: 'locationType',
  Squad: 'squad',
  CustomForm: 'customForm',
  PortalLink: 'portalLink',
  Activities: 'activities',
  FallbackLabel: 'fallbackLabel',
} as const;
